<app-doc-viewer title="Geometry Form" subtitle="Geo">
  <app-example-viewer codeFolder="geo/geometry">
    <div class="container">
      <igo-map-browser [map]="map" [view]="view">
        <div class="map-actions --vertical --bottom --right">
          <igo-zoom-button [map]="map" color="primary" />
        </div>
      </igo-map-browser>

      @if (form$ | async; as form) {
        <igo-form
          [form]="form"
          [formData]="data$ | async"
          (submitForm)="onSubmit($event)"
        >
          <igo-form-group [group]="form.groups[0]" />
          <div formButtons class="actions-container">
            <button
              mat-stroked-button
              type="button"
              color="primary"
              (click)="fillForm()"
            >
              Fill Form
            </button>
            <button
              mat-stroked-button
              type="button"
              color="primary"
              (click)="clearForm()"
            >
              Clear Form
            </button>
            <button
              mat-flat-button
              type="submit"
              color="primary"
              [disabled]="submitDisabled"
            >
              Submit
            </button>
          </div>
        </igo-form>
      }
    </div>
  </app-example-viewer>
</app-doc-viewer>
